// =============================================================================
// helpModal.ts — app-wide "show a help item in a modal" singleton
// =============================================================================
// Mirrors dialogService: a module-level singleton ANY code can drive without a
// React context. Calling showHelp(key) asks <HelpModalHost/> (mounted once at the
// app root) to fetch that help_content key and show it — the SAME text the (?)
// HelpButton bubbles render. Used by the Resources page's `#help=` deep links.
//
// Deliberately separate from HelpButton (which keeps its own modal): HelpButton is
// used in many places and stays untouched — this is a second, small, shared modal
// for the link path (John, 29 Aug).
// =============================================================================

type Listener = (key: string | null) => void;

let activeKey: string | null = null;
let listeners: Listener[] = [];

/** Open the help modal for a help_content key. */
export function showHelp(key: string): void {
  activeKey = String(key || "") || null;
  for (const l of listeners) l(activeKey);
}

/** Close the help modal. */
export function closeHelp(): void {
  activeKey = null;
  for (const l of listeners) l(null);
}

/** The currently-open help key, or null. */
export function getActiveHelpKey(): string | null {
  return activeKey;
}

/** Subscribe to open/close changes; fires immediately. Returns an unsubscribe fn. */
export function subscribeHelp(listener: Listener): () => void {
  listeners.push(listener);
  listener(activeKey);
  return function unsubscribe() {
    listeners = listeners.filter((l) => l !== listener);
  };
}
